import React, { memo, useState , useEffect} from "react";
import { Row ,Col,Card} from 'react-bootstrap';
import { useSelector } from 'react-redux';
import NetworkManager from './NetworkManager';
import SpeakingAndWriting from "components/FullTest/MockOperations/SpeakingAndWriting";
import Reading from "components/FullTest/MockOperations/Reading";
import Break from "components/FullTest/MockOperations/Break";
import Listening from "components/FullTest/MockOperations/Listening";
import TestFinished from "components/FullTest/MockOperations/TestFinished";
import SaveAndExitScreen from "components/FullTest/MockOperations/SaveAndExitScreen";
import TestFinishedDueToTimeout from "components/FullTest/MockOperations/TestFinishedDueToTimeout";
import FullScreen from "assets/images/FullScreen.png";
import DarkMode from "assets/images/DarkMode.png";
import ExitFullScreen from "assets/images/ExitFullScreen.png";
import LightMode from "assets/images/LightMode.png";
import { isFullScreen, isDarkMode } from "util/helper";

const MockTest = memo(function MockTest({
  setCheckPoint,
  mock,
  pending,
  startSection,
  toggleFullScreen,
  toggleTheme
}) {
  // console.log(mock,pending,startSection);
  const getCorrectSection = () => {
    const questionSubcategories = mock.mock.question.map(q => q.subcategory_id);
    
    if (questionSubcategories.some(id => [1, 2, 3, 4, 5, 6, 7, 21, 22].includes(id))) {
      return 1; // Speaking and Writing
    } else if (questionSubcategories.some(id => [8, 9, 10, 11, 12].includes(id))) {
      return 2; // Reading
    } else if (questionSubcategories.some(id => [13, 14, 15, 16, 17, 18, 19, 20].includes(id))) {
      return 4; // Listening
    }
    return startSection;
  };
  
  const [section, setSection] = useState(getCorrectSection());
  const intStatus = useSelector((state) => state.intStatus);
  const [isOnline, setIsOnline] = useState(true);
  const [localPending, setLocalPending] = useState(pending);
  const [, forceUpdate] = useState();

  const isFirstRender = React.useRef(true);
  // Reset pending to 0 when section changes
  React.useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    setLocalPending(0);
  }, [section]);
   useEffect(() => {
    const connection = typeof intStatus === "undefined" ? true : intStatus;
    setIsOnline(connection);
    
    if (connection) {
      NetworkManager.retryFailedRequests();
    }
  }, [intStatus]);

  useEffect(() => {
    if (section === 5) { // TestFinished
      setTimeout(() => {
        // Import and call submitFailed from Questions component
        // Or create a global submitFailed function
        NetworkManager.retryFailedRequests().then(() => {
          // Call submitFailed API after retrying failed requests
          const failedRequests = NetworkManager.getFailedRequests();
          if (failedRequests.length > 0) {
            let formData = new FormData();
            failedRequests.forEach((request, index) => {
              for (let [key, value] of request.data.entries()) {
                if (key === 'file[]') {
                  formData.append('files[]', value);
                } else {
                  formData.append(`data[${index}][${key}]`, value);
                }
              }
            });

            NetworkManager.submitWithRetry({
              method: 'POST',
              url: 'submitFailed/mock',
              data: formData
            }).then(() => {
              NetworkManager.clearFailedRequests();
            }).catch((err) => {
              console.log("Final submission of failed requests failed:", err);
            });
          }
        });
      }, 2000);
    }
  }, [section]);

  const sectionQuestions = () => {
    let subcategories = [];

    switch (section) {
      case 1:
        // speaking and writing
        subcategories = [1, 2, 3, 4, 5, 6, 7, 21, 22];
        break;
      case 2:
        // reading
        subcategories = [8, 9, 10, 11, 12];
        break;
      case 3:
        // break. just to sync.
        subcategories = [];
        break;
      case 4:
        // listening
        subcategories = [13, 14, 15, 16, 17, 18, 19, 20];
        break;
      default:
      // do nothing
    }
    
    const questions = mock.mock.question.filter((v) => 
      subcategories.includes(v.subcategory_id)
    );

    return questions;
  };  

  return (
    <>
      {/* {!isOnline && (
        <div className="global-network-warning">
          <div className="alert alert-warning">
            <i className="fa fa-exclamation-triangle"></i>
            You're currently offline. The test will continue and sync when connection is restored.
          </div>
        </div>
      )} */}
      {section === 1 && (
        <SpeakingAndWriting
          mockData={mock}
          questions={sectionQuestions()}
          setSection={setSection}
          pending={pending}
          isOnline={isOnline}
          localPending={localPending}
        />
      )}

      {section === 2 && (
        <Reading
          mockData={mock}
          questions={sectionQuestions()}
          setSection={setSection}
          pending={pending}
          isOnline={isOnline}
          localPending={localPending}
        />
      )}

      {[3, 5, 6, 10].includes(section) && (
        <>
          <div className="content questionsArea deviceTestPage old-design p-0 test_width mock-container" style={{minHeight: '50px'}}>
            <Row>
              <Col xs={12}>
                <Row className="m-0 test_width">
                  <Row
                    className="d-flex justify-content-between align-items-center w-100 h-50 mock-header-bg"
                    style={{
                      height: "40px	!important",
                    }}
                  >
                    <Col
                      style={{
                        width: "fit-content",
                        padding: "0",
                      }}
                    >
                      <Card.Title tag="h4" className="m-0 mx-2">
                        Language Academy - {mock.mock.title}
                      </Card.Title>
                    </Col>
                  </Row>
                  <Row
                    style={{
                      backgroundColor: "#0081A4",
                      minHeight: "40px",
                    }}
                    className="d-flex justify-content-end align-items-center px-4"
                  >
                    <div className="d-flex justify-content-end gap-3">
                    <img
                      src={isFullScreen() ? ExitFullScreen : FullScreen}
                      onClick={() => {
                      toggleFullScreen();
                      setTimeout(() => {
                        forceUpdate({});
                      }, 100);
                      }}
                      alt={isFullScreen() ? "Exit Full Screen" : "Full Screen"}
                      className="toggle-icons"
                    />
                    <img
                      src={isDarkMode() ? LightMode : DarkMode}
                      onClick={() => {
                      toggleTheme();
                      forceUpdate({});
                      }}
                      alt={isDarkMode() ? "Light Mode" : "Dark Mode"}
                      className="toggle-icons"
                    />
                    </div>
                  </Row>
                </Row>
              </Col>
            </Row>
          </div>
        </>
      )}      

      {section === 3 && <Break mock={mock.mock} setSection={setSection} />}

      {section === 4 && (
        <Listening
          mockData={mock}
          questions={sectionQuestions()}
          setSection={setSection}
          pending={pending}
          isOnline={isOnline}
          localPending={localPending}
        />
      )}

      {section === 5 && <TestFinished />}

      {section === 6 && <SaveAndExitScreen mockTitle={mock.mock.title} />}

      {section === 10 && <TestFinishedDueToTimeout />}
    </>
  );
});

export default MockTest;
